import React from "react";

const HorizontallPartition = () => {
    return (
        <svg width="108" height="25" viewBox="0 0 108 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect y="18" width="108" height="7" rx="3.5" fill="#4A5353" />
            <rect y="7" width="108" height="11" rx="5.5" fill="#B5C6C7" />
            <rect width="108" height="7" rx="3.5" fill="#4A5353" />
        </svg>
    )
}
export default HorizontallPartition;